var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3192 0.680785C14.2269 1.5885 14.2269 3.06019 13.3192 3.96791L4.73487 12.5523C4.36251 12.9246 3.89596 13.1888 3.38509 13.3165L0.722549 13.9821C0.296973 14.0885 -0.0885155 13.703 0.0178786 13.2774L0.683513 10.6149C0.81123 10.104 1.07539 9.63749 1.44775 9.26513L10.0321 0.680785C10.9398 -0.226928 12.4115 -0.226928 13.3192 0.680785ZM9.21022 3.146L2.26953 10.0869C2.04611 10.3103 1.88762 10.5903 1.81099 10.8968L1.38024 12.6198L3.10322 12.189C3.40974 12.1124 3.68967 11.9539 3.91309 11.7305L10.8535 4.78932L9.21022 3.146ZM10.8539 1.50257L10.0319 2.32435L11.6752 3.96766L12.4974 3.14613C12.9513 2.69227 12.9513 1.95642 12.4974 1.50257C12.0436 1.04871 11.3077 1.04871 10.8539 1.50257Z",
    fill: "#CAC4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.0777cfcc86cff2c83941a1fa3284ad62.svg";
export { ForwardRef as ReactComponent };